import Post from "../../Post/Post";
import RelatedSection from "../../Homepage/section/RelatedSection";
import React, {useContext, useEffect} from "react";
import {useTranslation} from "react-i18next";
import {ThreadContext} from "../../../context/threadContext";
import ReplyFormTemplate from "../section/ReplyFormTemplate";
import ReplyForm from "../section/ReplyForm";
import UserReadStats from "../section/UserReadStats";
import ReactPaginate from "react-paginate";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft, faChevronRight, faLock} from "@fortawesome/free-solid-svg-icons";
import LoadingContent from "../../common/LoadingContent";

const MainPostContent = () => {
	const {t} = useTranslation();

	const {
		thread,
		fetchUserReadData, fetchReplyTemplates,
		posts, pagination, handlePageChange, postsPage, fetchPosts,
		userReadData, replyTemplates
	} = useContext(ThreadContext);

	const handlePageClick = (e) => {
		handlePageChange(e);
	}

	useEffect(() => {
		if (thread && thread.can_reply_template) {
			fetchReplyTemplates();
		}

		if (thread && thread.can_view_who_read_wrt) {
			fetchUserReadData();
		}
	}, [fetchPosts, fetchReplyTemplates, fetchUserReadData, postsPage, thread]);

	return (
		<div>
			{thread && (
				<section className="mb-4">
					{posts && posts.length > 0 ? (
						<div>
							<ul>
								{posts.map((post, index) => (
									<li className="mb-4" id={`post-${post.post_id}`} key={post.post_id}>
										<Post thread={thread} post={post} postId={post.post_id} />

										{post.is_first_post && (
											<div className="mt-4">
												<h3 className="block-minorHeader">
													CÓ THỂ BẠN SẼ THÍCH GÁI GỌI
												</h3>

												<div className="mt-2">
													<RelatedSection />
												</div>
											</div>
										)}
									</li>
								))}
							</ul>

							{pagination.last_page > 1 && (
								<div className="mt-4">
									<ReactPaginate
										previousLabel={<span><FontAwesomeIcon icon={faChevronLeft} className="text-xs" /> Trang trước</span>}
										nextLabel={<span>Trang sau <FontAwesomeIcon icon={faChevronRight} className="text-xs" /></span>}
										breakLabel={"..."}
										breakClassName={"break-me"}
										pageCount={pagination.last_page}
										marginPagesDisplayed={2}
										pageRangeDisplayed={5}
										onPageChange={handlePageClick}
										containerClassName={"pagination"}
										subContainerClassName={"pages pagination"}
										activeClassName={"active"}
										initialPage={pagination.current_page - 1}
									/>
								</div>
							)}
						</div>
					) : (
						<LoadingContent />
					)}
				</section>
			)}

			{thread && thread.can_reply_template && (
				<>
					{replyTemplates && (
						<section className="mb-4">
							<ReplyFormTemplate thread={thread} templates={replyTemplates}/>
						</section>
					)}
				</>
			)}

			{thread && thread.can_reply && (
				<section className="mb-4">
					<ReplyForm thread={thread}/>
				</section>
			)}

			{(thread && !thread.discussion_open) && (
				<section className="mb-4">
					<div className="p-2 bg-secondary rounded text-white text-sm font-bold">
						<FontAwesomeIcon icon={faLock} className="mr-2" />
						Hiện không mở bình luận cho bài viết này
					</div>
				</section>
			)}

			{(thread && thread.can_view_who_read_wrt && userReadData) && (
				<section className="mb-4">
					<UserReadStats userReadData={userReadData}/>
				</section>
			)}
		</div>
	);
};

export default MainPostContent;